module.exports = __webpack_public_path__ + "img/4f_r_sanko_2.0b2e3162.jpg";